export const USER = {
    GET_USER_INFO: 'user/GET_USER_INFO',
    UPDATE_USER_INFO: 'user/UPDATE_USER_INFO',
    CLEAR_USER_INFO_MESS: 'user/CLEAR_USER_INFO_MESS',
    LOGOUT: 'user/LOGOUT',
    CHANGE_PASSWORD: 'user/CHANGE_PASSWORD',
    UPLOAD_AVATAR: 'user/UPLOAD_AVATAR',
    GET_POINT: 'user/GET_POINT',
    GET_INFO_MEMBER: 'user/GET_INFO_MEMBER',
};